import { connect } from 'react-redux';
import { selectors, actions } from '../Stream';
var mapStateToProps = function (state, _a) {
    var streamId = _a.streamId;
    return ({
        hasMore: selectors.hasMore(state, streamId),
        isFetching: selectors.isFetching(state, streamId),
        hasError: !!selectors.getErrorMsg(state, streamId),
        isEmpty: (selectors.getItems(state, streamId) || []).length === 0,
    });
};
var mapDispatchToProps = {
    fetchMore: actions.fetchNext,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=StreamedList.container.js.map